import { Middleware } from 'redux';
import rootReducer from '../reducers/index';
import { AppState } from '../../types/store';
import { create } from '@wix/fedops-logger';
import createFedopsLogger from './middleware/fedopsLogger';
import rootSaga from '../sagas';
import logger from '../utils/logger';
import { rootModuleStoreFactory } from '@wix/da-shared-react/pkg/redux/rootModuleStore/factory';

export function configureStore(initialState: Partial<AppState>): any {
  const middleware: Middleware[] = [];

  if (typeof window !== undefined) {
    middleware.push(createFedopsLogger(create('da-user-profile')) as any);
  }

  const store = rootModuleStoreFactory<Partial<AppState>>(
    middleware,
    logger,
    initialState,
    rootReducer as any,
    rootSaga,
    !initialState?.environment?.useNewRedux
  );

  // Its old redux
  if ((store as any).saga) {
    return store;
  }

  // new_redux change to return just store
  return {
    store,
    saga: {
      toPromise: () => Promise.resolve(),
    },
  };
}
